import Vue from 'vue'
import store from '@/modules/store'

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}
String.prototype.lowercase = function () {
    return this.toLowerCase()
}

Vue.filter('highlight', function (words, query) {
    let iQuery = new RegExp(query, 'ig')
    // eslint-disable-next-line
    return words?.toString()?.replace(iQuery, function (matchedTxt, a, b) {
        return query !== null
            ? '<span style="background-color: yellow;">' + matchedTxt + '</span>'
            : null
    })
})

Vue.filter('toDate', function (value) {
    const time = Vue.moment(value)
    return time && time.isValid()
        ? time.format(
              store.getters['locale'] === 'hu'
                  ? Vue.prototype.$dateFormat_HU
                  : Vue.prototype.$dateFormat_EN
          )
        : null
})

Vue.filter('toDateTime', function (value) {
    const time = Vue.moment(value)
    return time && time.isValid()
        ? time.format(
              store.getters['locale'] === 'hu'
                  ? Vue.prototype.$dateTimeFormat_HU
                  : Vue.prototype.$dateTimeFormat_EN
          )
        : null
})

Vue.filter('toDateTimeSecond', function (value) {
    const time = Vue.moment(value)
    return time && time.isValid()
        ? time.format(
              store.getters['locale'] === 'hu'
                  ? Vue.prototype.$dateTimeSecondFormat_HU
                  : Vue.prototype.$dateTimeSecondFormat_EN
          )
        : null
})

Vue.filter('toDayMonth', function (value, type = 2) {
    const time = Vue.moment(value)
    return time && time.isValid()
        ? time.format(
              store.getters['locale'] === 'hu'
                  ? Vue.prototype[`$dayMonthFormat_${type}_HU`]
                  : Vue.prototype[`$dayMonthFormat_${type}_EN`]
          )
        : null
})

Vue.filter('toDayMonthTime', function (value) {
    const time = Vue.moment(value)
    return time && time.isValid()
        ? time.format(
              store.getters['locale'] === 'hu'
                  ? Vue.prototype.$dayMonthTimeFormat_HU
                  : Vue.prototype.$dayMonthTimeFormat_EN
          )
        : null
})

Vue.filter('toTimeRange', function (value) {
    const time = Vue.moment(value)
    return time && time.isValid()
        ? `${time.format('HH:mm')} - ${time
              .add(Vue.prototype.$deliveryPeriod, 'minutes')
              .format('HH:mm')}`
        : null
})

Vue.filter('toHour', function (value) {
    const time = Vue.moment(value)
    return time && time.isValid() ? time.format(Vue.prototype.$hour) : null
})

Vue.filter('toYear', function (value) {
    const time = Vue.moment(value)
    return time && time.isValid() ? time.format(Vue.prototype.$year) : null
})

Vue.filter('toDeliveryTime', function (value) {
    const time = Vue.moment(value)
    if (!time && time.isValid()) return null
    const today = time ? Vue.moment().isSame(time, 'day') : false
    const tomorrow = time ? Vue.moment().add(1, 'day').isSame(time, 'day') : false
    return `${
        today
            ? Vue.i18n.translate('base.today')
            : tomorrow
            ? Vue.i18n.translate('base.tomorrow')
            : `${time.format(
                  store.getters['locale'] === 'hu'
                      ? Vue.prototype.$dayMonthFormat_1_HU
                      : Vue.prototype.$dayMonthFormat_1_EN
              )},`
    } ${time.format('HH:mm')} - ${time.add(Vue.prototype.$deliveryPeriod, 'minutes').format('HH:mm')}`
})

Vue.filter('toDeliveryDate', function (value) {
    const date = Vue.moment(value)
    if (!date && date.isValid()) return null
    const locale = store.getters['locale']
    if (Vue.moment().isSame(date, 'day'))
        return Vue.i18n.translate('labels.today', {
            time: Vue.moment(date).locale(locale).format(Vue.prototype.$hour),
        })
    else if (Vue.moment().add(1, 'days').isSame(date, 'day'))
        return Vue.i18n.translate('labels.tomorrow', {
            time: Vue.moment(date).locale(locale).format(Vue.prototype.$hour),
        })
    else
        return Vue.moment(date)
            .locale(locale)
            .format(
                locale === 'hu'
                    ? Vue.prototype.$dayMonthTimeFormat_HU
                    : Vue.prototype.$dayMonthTimeFormat_EN
            )
})

/**
 * Formats a delivery slot (start/end RFC3339 strings from the restaurant search API) as
 * "Today 11:00 - 11:30" / "Tomorrow 11:00 - 11:30" / "Sat, 19 Sep, 11:00 - 11:30".
 * The day label follows the slot START; both ends are formatted in the app timezone.
 * Returns null when either value is missing or not a valid date – moment(undefined)
 * would silently mean "now", so the type check must come before parsing.
 */
Vue.filter('toDeliveryDateRange', function (start, end) {
    const isNonEmptyString = (value) => typeof value === 'string' && value.trim() !== ''
    if (!isNonEmptyString(start) || !isNonEmptyString(end)) return null

    const startTime = Vue.moment(start)
    const endTime = Vue.moment(end)
    if (!startTime.isValid() || !endTime.isValid()) return null

    const now = Vue.moment()
    const locale = store.getters['locale']
    const range = `${startTime.format(Vue.prototype.$hour)} - ${endTime.format(
        Vue.prototype.$hour
    )}`

    if (startTime.isSame(now, 'day')) return Vue.i18n.translate('labels.today', { time: range })
    if (startTime.isSame(now.clone().add(1, 'day'), 'day'))
        return Vue.i18n.translate('labels.tomorrow', { time: range })

    return `${startTime
        .locale(locale)
        .format(
            locale === 'hu'
                ? Vue.prototype.$dayMonthFormat_1_HU
                : Vue.prototype.$dayMonthFormat_1_EN
        )}, ${range}`
})

Vue.filter('toCalendarDay', function (value) {
    const time = value && value._isAMomentObject ? Vue.moment(value) : Vue.moment.utc(value)
    return time && time.isValid()
        ? `<small>${time.calendar()}</small><span>${time.format('DD')}</span>`
        : null
})
Vue.filter('toSelectDay', function (value, locale) {
    const time = value && value._isAMomentObject ? Vue.moment(value) : Vue.moment.utc(value)
    return time && time.isValid()
        ? time.calendar(null, Vue.prototype.$calendarFormat2(locale))
        : null
})

Vue.filter('toNumber', function (value) {
    let n = parseFloat(value)
    return isNaN(n) ? value : n
})

Vue.filter('toCal', function (value) {
    return value ? `${value} kcal` : undefined
})

// Vue.filter('truncateText', (value, maxLength = 100) => {
//     let trimmed = value
//     if (value && value.length > maxLength)
//     {
//         trimmed = value.substr(0, maxLength)
//         trimmed = trimmed.substr(0, Math.min(trimmed.length, trimmed.lastIndexOf(" ")))
//     }
//     if (trimmed !== value)
//         trimmed = `${trimmed} …`
//     return trimmed
// })

Vue.filter('toCurrency', function (value, locale, currency) {
    if (isNaN(value)) return ''
    locale = locale || store.getters['site/config']?.site_locale || 'hu-HU'
    currency = currency || store.getters['site/config']?.currency_code || 'HUF'
    return Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: locale === 'hu-HU' ? 0 : 2,
    }).format(value)
})
